import * as React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { Avatar, ContainerHtmlStyle, Flex, Grid, Spacer, StarRating, Text, Title } from '@siteground/styleguide';

import { getOperatorInfo, getLanguagesMapping } from '../../../../selectors/operator';
import { getLanguage } from '../../../../selectors/chat-session';
import { getLanguagePrefix } from '../../../../utils/language';
import './content.css';

const OperatorInfoContent = () => {
  const intl = useIntl();
  const operator = useSelector(getOperatorInfo);
  const languages = useSelector(getLanguagesMapping);
  const userLanguage = useSelector(getLanguage);
  const languagePrefix = getLanguagePrefix(userLanguage);

  const { first_name, last_name, avatar, job_title, employ_from, rating, biography: biographyByLanguageId } = operator;

  const currentLanguageData = languages.find((langData) => langData.language.toLowerCase() === languagePrefix);

  const bio =
    currentLanguageData &&
    currentLanguageData.id &&
    biographyByLanguageId &&
    biographyByLanguageId[currentLanguageData.id];

  return (
    <Grid padding="x-small">
      <Flex justify="center">
        <Avatar size="84" firstName={first_name} lastName={last_name} src={avatar} />
      </Flex>

      <div>
        <Title align="center" level="3" weight="bold">
          {first_name} {last_name}
        </Title>
        <Text align="center" size="large">
          {job_title}
        </Text>
      </div>

      <Grid gap="xx-small">
        <Text align="center" color="typography-tertiary">
          {intl.formatMessage({ id: 'translate.operator.info.employ.from.label' })}
          &nbsp;
          {employ_from}
        </Text>

        {Boolean(rating) && (
          <Flex justify="center" align="center">
            <Text size="small" color="typography-tertiary">
              {intl.formatMessage({ id: 'translate.operator.info.rate.label' })}
              &nbsp;
            </Text>

            <Spacer size="xx-small" />

            <StarRating size="small" rating={Number(rating)} />
          </Flex>
        )}
      </Grid>

      <ContainerHtmlStyle className="operator-bio--css-overwrite" parseHTML={bio} />
    </Grid>
  );
};

export default OperatorInfoContent;
